<template>
  <div class="page">
    <!-- 财税报告 -->
    <div class="left" @click="toPage(enterpriseServicesRowData[0])">
      <img :src="enterpriseServicesRowData[0].bg" alt="" />
    </div>
    <div class="right">
      <!-- 企业测额 -->
      <div class="right-top" @click="toPage(enterpriseServicesRowData[1])">
        <img :src="enterpriseServicesRowData[1].bg" alt="" />
      </div>
      <!-- 信用修复 -->
      <div class="right-bottom" @click="toPage(enterpriseServicesRowData[2])">
        <img :src="enterpriseServicesRowData[2].bg" alt="" />
      </div>
    </div>
    <van-dialog
      class="reportPosterShow"
      v-model="reportPosterShow"
      close-on-click-overlay
      :showConfirmButton="false"
    >
      <img :src="reportPosterImg" />
    </van-dialog>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth.js";
import { getCurrentChannelInfo } from "@/api/login.js";
import { genCompanyRepoPost } from "@/api/product.js";
import { Toast, Dialog } from "vant";
import { xcDepConfig } from "@/api/depConfig.js";
import { getDepNameByDomain } from "@/utils/index";
Vue.use(Toast);
import Vue from "vue";
export default {
  created() {
    this.getDepConfig();
  },
  data() {
    return {
      // 当前平台名称
      depName: "",
      reportPosterShow: false,
      reportPosterImg: "",
      // 企业服务合集
      enterpriseServicesRowData: [
        {
          bg: "https://static.xchengtech.cn/ea13b2a7259848cdb2755250e7577de1.jpg",
          name: "财税报告",
        },
        {
          bg: "https://static.xchengtech.cn/7eeda28ec6d6486e8538222fd7a75d2f.jpg",
          name: "企业测额",
          url: "https://page.xchengtech.cn/creditTest/index.html",
        },
        {
          bg: "https://static.xchengtech.cn/35336e57060441e18504407a6031e8a5.jpg",
          name: "信用修复",
          url: "https://h5.besodata.com/#/pages/creditRepair/home?tenantCode=xcsz&platform=HXFY",
        },
      ],
    };
  },
  methods: {
    getDepConfig() {
      // 判断当前平台
      this.depName = getDepNameByDomain();
    },
    toPage(item) {
      // 判断是否登录
      if (getToken()) {
        // 财税报告
        if (item.name == "财税报告") {
          Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: "加载中",
          });
          // 获取企业报告
          genCompanyRepoPost()
            .then((res) => {
              window.location.href = res.link;
              Toast.clear();
              // this.reportPosterImg = res.posterUrl;
              // this.reportPosterShow = true;
            })
            .catch((errr) => {
              console.log("errr", errr);
              Toast.clear();
            });
        } else if (item.name == "企业测额") {
          Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: "加载中",
          });
          // 获取渠道用户信息
          getCurrentChannelInfo()
            .then((res) => {
              // 判断是否为广州好邻 是的话则去留资界面 而不是企业测额界面
              if (this.depName == "gzhlkj") {
                this.toUrl(
                  "https://page.xchengtech.cn/productPage/qyce.html?channelId=" +
                    res.id
                );
              }
              // 其他
              else {
                this.toUrl(item.url + "?channelId=" + res.id);
              }
              console.log("res", res);
            })
            .catch((err) => {
              console.log("err", err);
              Toast.clear();
            });
        } else if (item.name == "信用修复") {
          Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: "加载中",
          });
          // 判断是否为广州好邻 是的话则去留资界面 而不是信用修复界面
          if (this.depName == "gzhlkj") {
            // 获取渠道用户信息
            getCurrentChannelInfo()
              .then((res) => {
                this.toUrl(
                  "https://page.xchengtech.cn/productPage/xyxf.html?channelId=" +
                    res.id
                );
              })
              .catch((err) => {
                console.log("err", err);
                Toast.clear();
              });
          } else {
            if (item.url) {
              this.toUrl(item.url);
            }
          }
        } else {
          if (item.url) {
            this.toUrl(item.url);
          }
        }
      } else {
        this.$router.push({
          path: "/login",
        });
      }
    },
    toUrl(url) {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
      console.log("utl", url);
      window.location.href = url;
      Toast.clear();
    },
  },
};
</script>
<style scoped>
/* 图标地址 */
/* https://www.iconfont.cn/illustrations/detail?spm=a313x.illustrations_index.i1.d9df05512.56143a81yJK2gE&cid=38659 */
.page {
  /* margin-top: 7vw; */
  padding: 7vw 4vw 0 4vw;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3vw;
}
.title {
  font-weight: 600;
  font-size: 4.2vw;
  color: #3c4047;
}
.desc {
  font-size: 3.2vw;
  line-height: 5vw;
  color: #63778c;
}
.left {
}
.left img {
  display: block;
  width: 100%;
  border-radius: 14px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(0, 0, 0, 0.02);
}
.right {
  display: grid;
  gap: 3vw;
}

.right img {
  display: block;
  width: 100%;
  /* height: 100%; */
  border-radius: 14px;
  /* overflow: hidden; */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(0, 0, 0, 0.02);
}
.right .right-top {
}
.right .right-bottom {
}
.reportPosterShow {
  border-radius: 0;
}
.reportPosterShow img {
  display: block;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/view/productList/module/enterpriseServices.vue